(function () {
  function normalizeImageUrl(url) {
    if (!url) return "";

    let normalizedUrl = url.replace(/&amp;/g, "&");

    if (normalizedUrl.startsWith("//")) {
      normalizedUrl = window.location.protocol + normalizedUrl;
    }

    return normalizedUrl;
  }

  function getImagePath(url) {
    const normalizedUrl = normalizeImageUrl(url);

    try {
      return new URL(normalizedUrl, window.location.origin).pathname;
    } catch (error) {
      return normalizedUrl.split("?")[0];
    }
  }

  function updateMainProductImage(card, imageUrl, colorName) {
    const mediaContainer = card.querySelector(
      ".media.media--hover-effect, .card__media .media"
    );

    if (!mediaContainer) return;

    const mainImage = mediaContainer.querySelector("img:first-of-type");

    if (!mainImage) return;

    const normalizedImageUrl = normalizeImageUrl(imageUrl);

    mainImage.src = normalizedImageUrl;
    mainImage.srcset = normalizedImageUrl;
    mainImage.setAttribute("src", normalizedImageUrl);
    mainImage.setAttribute("srcset", normalizedImageUrl);
    mainImage.removeAttribute("loading");
    mainImage.classList.remove("lazyload", "lazyloading");

    if (colorName) {
      mainImage.alt = colorName;
    }

    const picture = mainImage.closest("picture");

    if (picture) {
      picture.querySelectorAll("source").forEach(function (source) {
        source.srcset = normalizedImageUrl;
      });
    }

    if (window.lazySizes && window.lazySizes.loader) {
      window.lazySizes.loader.unveil(mainImage);
    }
  }

  function updateSelectedColor(card, colorName) {
    const colorLabel = card.querySelector(".product-color-name");

    if (colorLabel) {
      colorLabel.textContent = colorName;
    }
  }

  function updateProductLinks(card, variantId) {
    if (!variantId) return;

    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set("variant", variantId);
        link.href = url.toString();
      } catch (error) {
        console.warn("Could not update product link:", error);
      }
    });
  }

  function initializeProductCard(card) {
    if (!card || card.dataset.swatchesInitialized === "true") return;

    const swatches = card.querySelectorAll(".product-swatches .swatch");

    if (!swatches.length) return;

    card.dataset.swatchesInitialized = "true";

    const mainImage = card.querySelector(
      ".media.media--hover-effect img:first-of-type, .card__media .media img:first-of-type"
    );

    const currentImagePath = mainImage
      ? getImagePath(mainImage.currentSrc || mainImage.src)
      : "";

    let initialSwatch = null;

    swatches.forEach(function (swatch) {
      const swatchImagePath = getImagePath(swatch.dataset.image || "");

      if (
        !initialSwatch &&
        currentImagePath &&
        swatchImagePath &&
        currentImagePath === swatchImagePath
      ) {
        initialSwatch = swatch;
      }
    });

    if (!initialSwatch) {
      initialSwatch = swatches[0];
    }

    if (initialSwatch) {
      initialSwatch.classList.add("active");
      initialSwatch.setAttribute("aria-selected", "true");

      updateSelectedColor(
        card,
        (initialSwatch.dataset.color || "").trim()
      );
    }

    swatches.forEach(function (swatch) {
      swatch.setAttribute("role", "button");
      swatch.setAttribute("tabindex", "0");
      swatch.setAttribute(
        "aria-selected",
        swatch.classList.contains("active") ? "true" : "false"
      );

      function selectSwatch(event) {
        event.preventDefault();
        event.stopPropagation();

        const colorName = (swatch.dataset.color || "").trim();
        const imageUrl = swatch.dataset.image || "";
        const variantId = swatch.dataset.variantId || "";

        if (!imageUrl) {
          console.warn("No image assigned to swatch:", colorName);
          return;
        }

        card
          .querySelectorAll(".product-swatches .swatch")
          .forEach(function (item) {
            item.classList.remove("active");
            item.setAttribute("aria-selected", "false");
          });

        swatch.classList.add("active");
        swatch.setAttribute("aria-selected", "true");

        updateMainProductImage(card, imageUrl, colorName);
        updateSelectedColor(card, colorName);
        updateProductLinks(card, variantId);
      }

      swatch.addEventListener("click", selectSwatch);

      swatch.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          selectSwatch(event);
        }
      });
    });
  }

  function initializeAllProductCards(container) {
    const scope = container || document;

    scope.querySelectorAll(".card-wrapper").forEach(function (card) {
      initializeProductCard(card);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeAllProductCards(document);
    });
  } else {
    initializeAllProductCards(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeAllProductCards(event.target);
  });
})();